/*
  is-video-hero.js — Individual Socks, 28/08/2026

  Accende il filmato dell'hero dopo che la pagina e' disegnata.

  Perche'. Il filmato veniva chiesto subito, insieme a tutto il resto, e su una
  rete lenta arrivava dopo 13 secondi tenendo occupata la banda. Ora l'elemento
  piu' grande della pagina e' il fotogramma di anteprima, che e' un'immagine da
  64 KB: si vede quasi subito. Il filmato parte dopo, e chi guarda non si accorge
  del cambio.

  Come. Il tag <video> esce dal tema con data-src invece di src. Qui si aspetta
  che la pagina abbia finito di caricare, si aggiunge la sorgente e si avvia.
  Se questo file non venisse eseguito, resta l'anteprima: nessuna pagina rotta.
*/
(function () {
  'use strict';

  function accendi(video) {
    if (video.dataset.acceso === '1') return;
    video.dataset.acceso = '1';
    var src = video.getAttribute('data-src');
    var hls = video.getAttribute('data-hls');
    if (!src && !hls) return;

    // Prima lo stream adattivo: Safari lo legge e sceglie da solo la qualita' in
    // base alla rete di chi guarda. Gli altri browser non lo riconoscono e passano
    // alla sorgente successiva da soli: e' il comportamento normale di <video>.
    if (hls) {
      var sHls = document.createElement('source');
      sHls.setAttribute('src', hls);
      sHls.setAttribute('type', 'application/vnd.apple.mpegurl');
      video.appendChild(sHls);
    }
    if (src) {
      var source = document.createElement('source');
      source.setAttribute('src', src);
      source.setAttribute('type', video.getAttribute('data-mime') || 'video/mp4');
      video.appendChild(source);
    }
    video.load();
    var p = video.play();
    // su alcuni browser play() rifiuta se la scheda non e' in primo piano:
    // non e' un errore da mostrare, il filmato ripartira' da solo.
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function avvia() {
    var video = document.querySelectorAll('video.hero__video[data-src], video.hero__video[data-hls]');
    if (!video.length) return;

    // se il browser sa dire quando un elemento entra in vista, si aspetta quello:
    // un hero fuori schermo non deve scaricare niente.
    if ('IntersectionObserver' in window) {
      var osservatore = new IntersectionObserver(function (voci) {
        voci.forEach(function (v) {
          if (v.isIntersecting) {
            accendi(v.target);
            osservatore.unobserve(v.target);
          }
        });
      }, { rootMargin: '200px' });
      video.forEach(function (v) { osservatore.observe(v); });
      return;
    }
    video.forEach(accendi);
  }

  // "load" e' il momento in cui la pagina ha finito: dopo, la banda e' libera.
  if (document.readyState === 'complete') {
    avvia();
  } else {
    window.addEventListener('load', avvia, { once: true });
  }
})();
